
  import {Component, Vue} from "vue-property-decorator";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IAgentReport} from "@/modules/Report/interfaces/agent-report.interface";
  import {getHtmlAgentSummary} from "@/modules/Report/mixins/print-agent-report";

  @Component({})
  export default class ReportAgentSummary extends Vue {

    summaryHtml: string = '';

    get storeState(): IAppState { return this.$store.state; }
    get summary(): IAgentReport.IAgentSummary { return this.storeState.report.reportPayload?.summary; }

    created() {
      this.summaryHtml = getHtmlAgentSummary(this.summary);
    }
  }
